import { type FunctionComponent } from 'react';
import { type TrackedEvent } from '../../../../helpers/analytics/event-types';
import { type ProductSwatch } from '../../../../types/product.types';
import { ProductCardSwatchSelector } from '../../../product-components/product-card-swatch-selector/product-card-swatch-selector.component';

export type SwatchesProps = {
	swatches: ProductSwatch[];
	maxNumberToDisplay: number;
	isTileView: boolean;
	scrollEvent: TrackedEvent;
	selectEvent?: TrackedEvent;
	allowSingleSwatch?: boolean;
	className?: string;
};

export const Swatches: FunctionComponent<SwatchesProps> = ({
	swatches,
	maxNumberToDisplay,
	isTileView,
	scrollEvent,
	selectEvent,
	allowSingleSwatch,
	className = ''
}) => {
	return (
		<div className={className}>
			<ProductCardSwatchSelector
				swatches={swatches}
				maxNumberToDisplay={maxNumberToDisplay}
				isTileView={isTileView}
				scrollEvent={scrollEvent}
				selectEvent={selectEvent}
				allowSingleSwatch={allowSingleSwatch}
			/>
		</div>
	);
};
